export default "__VITE_ASSET__Bx$7tKl8__"